import * as Dtos from '../dtos/Tmd.dtos';
import { replace } from 'react-router-redux';

export function RouterReplace(store: any, url: string): void {
    if (!store || !store.dispatch) {
        return;
    }

    store.dispatch(replace(url));
};

/**
 * Parses a route param string into a numeric ID.
 * Returns `undefined` when the param is absent or not a valid number,
 * so that a value of `0` is treated as a valid ID rather than falsy.
 *
 * Usage:
 *   const id = parseRouteParamId(params.someId);
 *   if (id !== undefined) { // load existing record }
 *   else               { // create new record }
 */
export function parseRouteParamId(param: string | undefined): number | undefined {
    const id = parseInt(param, 10);
    return isNaN(id) ? undefined : id;
}
